import req from './BaseModule'
import store from '../../../store'
// GET
// //* 頻道 *//
// // 取得頻道-選項資訊
// export const getChannelSelectionsData = () => {
//   return req.get(store.getters.baseURL + "channels/info")
// }
// 取得個人資料訊
export const getPersonalData = (token) => {
  var config = {
    Authorization: `Bearer ${token}`,
    'X-Requested-With': 'XMLHttpRequest'
    // 'Device-id': 'hello-my-app-hello',
    // 'Device-Model': 'hello-my-app-hello',
    // 'Device-Name': 'hello-my-app-hello',

  }
  const url = store.getters.baseURL + 'credentials'
  //  let url = "https://test.jinfm.net/ear/public/api/mobile/v1/credentials"

  return req.postWithHeaders(url, {}, config)
}

export const getPersonalDataForPatch = (nickname, img, token) => {
  var config = {
    Authorization: `Bearer ${token}`,
    'X-Requested-With': 'XMLHttpRequest'
    // 'Device-id': 'hello-my-app-hello',
    // 'Device-Model': 'hello-my-app-hello',
    // 'Device-Name': 'hello-my-app-hello',

  }

  var data

  if (img === '') {
    data = {
      nickname: nickname
    }
  } else {
    data = {
      nickname: nickname,
      avatar: img

    }
  }

  const url = store.getters.baseURL + 'credentials'
  //  let url = "https://test.jinfm.net/ear/public/api/mobile/v1/credentials"

  return req.patchWithHeaders(url, data, config)
}

// 取得優惠券
export const getCoupon = (token) => {
  var config = {
    Authorization: `Bearer ${token}`,
    'X-Requested-With': 'XMLHttpRequest'

  }
  const url = store.getters.baseURL + 'coupons'

  return req.postWithHeaders(url, {}, config)
}
// 取得個人資料
// export const getPersonalData = (token) => {
//

//   var params = {

//   }

//   axios({
//     method: 'post',
//     url,
//     data: params,
//     headers
//   }).then(res => {
//     return res
//   })
// }

// // 取得編輯主播基本資料
// export const getAnchorEditingData = (id) => {
//     return req.get(store.getters.baseURL + 'authors/' + id)
// }

// // 取得編輯主播列表
// export const getAnchorList = () => {
//   return req.get(store.getters.baseURL + 'authors', params)
// }



// WEBPACK FOOTER //
// ./src/assets/js/api/api.js